module.exports = __webpack_public_path__ + "static/media/Agenda3.a7f8eaf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda3.png
// module id = 1967
// module chunks = 0